
import { getComponent } from './FormFieldMap'
import { getRule } from './FormFieldRules'
export default {
  name: 'FormElement',
  props: {
    value: {
      type: [Object, Array, String, Number, Boolean],
      default: () => ({})
    },
    schema: {
      type: Object,
      default: () => ({})
    },
    formData: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
    }
  },
  computed: {
    generatedRules () {
      const rules = this.schema?.options?.rules || []
      return rules.map((rule) => {
        return getRule(rule, this.formData)
      })
    }
    // generatedFormRender () {
    //   const schema = this.schema
    //   return Object.proptotype.hasOwnProperty.call(schema, 'conditionalRender') ? this.checkConditional(schema.conditionalRender) : true
    // }
  },
  methods: {
    mapComponent (type) {
      return getComponent(type) ? getComponent(type) : type
    },
    emitUp (emits) {
      this.$emit('emitUp', emits)
    }
  }

}
